import { z } from 'zod';

export type MateriaOutput = {
  id: string;
  nome: string;
};

export const MateriaCreateInput = z.object({ nome: z.string().min(1) });

export const MateriaUpdateInput = z
  .object({
    nome: z.string().min(1).optional(),
  })
  .partial();

export type ConteudoOutput = {
  id: string;
  materiaId: string;
  nome: string;
};

export const ConteudoCreateInput = z.object({
  materiaId: z.uuid(),
  nome: z.string().min(1),
});

export const ConteudoUpdateInput = ConteudoCreateInput.partial();

export type MateriaOutputType = MateriaOutput;
export type MateriaCreateInputType = z.infer<typeof MateriaCreateInput>;
export type MateriaUpdateInputType = z.infer<typeof MateriaUpdateInput>;
export type ConteudoOutputType = ConteudoOutput;
export type ConteudoCreateInputType = z.infer<typeof ConteudoCreateInput>;
export type ConteudoUpdateInputType = z.infer<typeof ConteudoUpdateInput>;
